import {
  collectBrowserRuntimeCapabilities,
  getBrowserRuntimeCapabilityMap,
} from "./browserRuntimeCapabilities";
import { logger } from "./logger";

export const OPEN_RUNTIME_DIAGNOSTICS_EVENT = "runtime-diagnostics-show";

const WARNING_TOAST_DURATION_MS = 12000;
const WARNING_TOAST_THROTTLE_MS = 10000;
const lastWarningToastAtByContext = new Map<string, number>();
const capabilityWarningToastDetail = {
  tone: "warning",
  action: {
    label: "Open runtime details",
    event: OPEN_RUNTIME_DIAGNOSTICS_EVENT,
  },
  durationMs: WARNING_TOAST_DURATION_MS,
};

function dispatchCapabilityWarning(message: string, context: string): void {
  const now = Date.now();
  const lastToastAt = lastWarningToastAtByContext.get(context) || 0;
  if (now - lastToastAt < WARNING_TOAST_THROTTLE_MS) return;
  lastWarningToastAtByContext.set(context, now);

  try {
    window.dispatchEvent(
      new CustomEvent("critter-toast", {
        detail: {
          message,
          ...capabilityWarningToastDetail,
        },
      })
    );
  } catch (error) {
    logger.warn(`[browser-capability] Failed to dispatch ${context} warning toast`, error);
  }
}

export function showWebGl2UnavailableToastIfNeeded(): void {
  const capabilityMap = getBrowserRuntimeCapabilityMap(collectBrowserRuntimeCapabilities());
  if (capabilityMap.webgl2) return;
  dispatchCapabilityWarning(
    "WebGL2 is unavailable. The 3D viewer may not render correctly.",
    "webgl2"
  );
}

export function showWebCryptoUnavailableToast(workflowLabel: string): void {
  dispatchCapabilityWarning(
    `${workflowLabel} needs Web Crypto hashing, but crypto.subtle is unavailable in this browser session.`,
    "web-crypto"
  );
}

export function showClipboardUnavailableToast(): void {
  dispatchCapabilityWarning(
    "Clipboard access is unavailable. The report could not be copied.",
    "clipboard"
  );
}
